import { getLayoutComponents, loadComponent } from '@boozt/helper';
import { setFetchHandler } from '@boozt/modules/api/handlers';
import type { FetchFunction } from '@boozt/modules/api/types';
import type { ApiResponseRouterPage } from '@boozt/types';
import { hydrateRoot } from 'react-dom/client';

require('@shopboozt/init');

type GlobalWindow = {
    ReactOnNode: {
        page: ApiResponseRouterPage;
        props: any;
        state: any;
        context: any;
    };
};

const globalWindow = window as unknown as GlobalWindow;

function loadDeferredCSS(href: string) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.media = 'all';
    document.head.appendChild(link);
}

async function bootstrap() {
    await setFetchHandler(
        '/',
        window.fetch.bind(window) as FetchFunction,
    ).then(() => null);

    window.addEventListener('load', () => {
        document.querySelectorAll('[data-css-post-load]').forEach((element): void => {
            if (element instanceof HTMLLinkElement) {
                loadDeferredCSS(element.dataset.cssPostLoad as string);
            }
        });
    });
}

bootstrap().then(() => null);

const components = getLayoutComponents();

const {
    page,
    context,
    state,
    props,
} = globalWindow.ReactOnNode;

const appProps = {
    page, props, context,
};

const idle = window.requestIdleCallback || function fallbackIdleCallback(cb: () => void) {
    setTimeout(cb, 0);
};

Object.keys(components).forEach((name) => {
    const element = document.getElementById(`hydrate-${name}`);

    if (element) {
        idle(() => {
            hydrateRoot(
                element,
                loadComponent(components[name], appProps, state),
            );
        });
    }
});
